import { createMemoryHistory, createRouter } from "vue-router";
import HomePage from "../pages/HomePage.vue";


const routes = [
  { 
    path: "/", component: HomePage,
  },
  // { 
  //   path: "/carte-routiere", component: HomePage,
  //   name: "carte-routiere",
  // },
  
  //   { path: '/about', component: AboutView },
];

const router = createRouter({
  history: createMemoryHistory(),
  routes,
});


export default router;
